import React__default from 'react';
import '@costar-ui/cosmos';
import { ArticlePromoWithImage, ImageOrientation } from '../article-promo/article-promo-with-image.esm.js';
import { ArticleTitle } from '../atoms/article-title/article-title.esm.js';
import { CategoryBar } from '../atoms/category-bar/category-bar.esm.js';

var MainVideoLayout = function MainVideoLayout(_ref) {
  var articleTitleLink = _ref.articleTitleLink,
    categoryLink = _ref.categoryLink,
    articleImage = _ref.articleImage,
    logoComponent = _ref.logoComponent;
  var featuredArticleTitle = /*#__PURE__*/React__default.createElement(ArticleTitle, {
    className: "text-p-16/5 sm:text-p-18/6"
  }, articleTitleLink);
  var featuredArticleImage = /*#__PURE__*/React__default.createElement("div", {
    className: "relative aspect-3/2 w-full"
  }, articleImage);
  var categoryBarElement = /*#__PURE__*/React__default.createElement(CategoryBar, null, categoryLink);
  return /*#__PURE__*/React__default.createElement("article", {
    className: "flex flex-col gap-6"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex w-full justify-center"
  }, /*#__PURE__*/React__default.createElement("figure", {
    className: "h-10 w-[135px]"
  }, logoComponent)), /*#__PURE__*/React__default.createElement(ArticlePromoWithImage, {
    articleTitleElement: featuredArticleTitle,
    categoryBarElement: categoryBarElement,
    imageElement: featuredArticleImage,
    imageOrientation: ImageOrientation.Top
  }));
};

export { MainVideoLayout };
//# sourceMappingURL=main-video-layout.esm.js.map
